/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import { RootState } from '@ink-ai/portal/reducers';
import { fetchAppParam } from '@ink-ai/portal/reducers/app';
import { CircularProgress } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const Initializer = () => {
  const dispatch = useDispatch<any>();
  const appState = useSelector((state: RootState) => state.app);
  useEffect(() => {
    dispatch(fetchAppParam());
  }, []);

  return (
    <div className="pt-24">
      {appState.isInitializing && (
        <div className="text-center">
          <CircularProgress size={80} />
        </div>
      )}
    </div>
  );
};
